import { v4 as uuidv4 } from 'uuid';
import { Action, AgentParticipant, EndpointParticipant } from "./conversation.model";
import { EndpointRank } from '../../../sdk/Alg/chat-constants';


export class EmailThreadModel {
    _id?: any;
    uuid: string;
    email_status: string;
    revision: string;
    status: string;
    vrsn: string;
    gateway: string;
    thread_id: string;
    create_date: Date;
    update_date: Date;
    subject: string; 
    unread_messages: number;
    endpoint_participants: EndpointParticipant[];
    active_session: Boolean;
    preferred_qr_code?: string;
    assign_date?: Date;
    agent_participants?: AgentParticipant[];
    created_by?: string;
    updated_by?: string;
    action?: Action;
    email_count?: number;
    current_task_guid?: string;
    current_outbound_task_guid?: string;
    agent_participants_outbound?: AgentParticipant[];
    email_thread_state?: string;
    spam?:string;

  constructor(vrsn: string, userGuid: string, vcGuid: string, userName: string, vcName: string, thread_id: string,
    subject: string) {
    this.uuid = uuidv4();
    this.email_status = "OPEN";
    this.revision = uuidv4();
    this.status = "ACTIVE";
    this.vrsn = vrsn;
    this.gateway = "sendgrid";
    this.thread_id = thread_id;
    this.create_date = new Date();
    this.update_date = new Date();
    this.subject = subject;
    this.unread_messages = 0;
    this.active_session = false;

    const userParticipant: EndpointParticipant = {
      uuid: userGuid,
      rank: EndpointRank.owner,
      name: userName
    };

    const endpointParticipant: EndpointParticipant = {
      uuid: vcGuid,
      rank: EndpointRank.virtual,
      name: vcName
    };

    this.endpoint_participants = [userParticipant, endpointParticipant];
  }
}
